import * as React from "react";
import classnames from "classnames";

interface IListHeaderDropdownProps {
  text: string;
  actions?: {
    text: string;
    onClick?: () => void;
    link?: string;
    iconClass?: string;
  }[];
}

const ListHeaderDropdown: React.FunctionComponent<IListHeaderDropdownProps> = (
  props
) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div className="dropdown dropdown-action" onBlur={() => setIsOpen(false)}>
      <button
        className="dropdown-click btn btn-primary btn-action font-normal font-weight-bold d-flex align-items-center p-0"
        type="button"
        id="dropdownMenuButton"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <span className="p-2 action-border">
          <span className="pl-1 pr-3">{props.text}</span>
        </span>
        <span className="p-2">
          <i className="icon-caret-down d-flex px-1"></i>
        </span>
      </button>
      <div
        className={classnames({
          "dropdown-menu dropdown-shadow font-sm border-0 w-100": true,
          in: isOpen,
        })}
      >
        {props.actions?.map((action, index) => {
          return (
            <a
              key={index}
              className="d-flex dropdown-item font-weight-semibold px-3 py-2"
              href={action.link || "#"}
              onClick={action.onClick}
            >
              {action.iconClass && (
                <div
                  className={`rounded ${action.iconClass} text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2`}
                  style={{ width: "20px", height: "20px" }}
                >
                  <i className="icon-chevron-right"></i>
                </div>
              )}

              <div className="d-flex">{action.text}</div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ListHeaderDropdown;
